import { GET_FILE_BY_TYPE_CLAVE_FILENAME, GET_FILE_BY_ID } from '@/graphQLQueries/DocStoreQueries'

var DownloadsMixin = {
  methods: {
    downloadFromUri(filename, uri) {
      var link = document.createElement("a");
      link.download = filename;
      link.href = uri;
      document.body.appendChild(link);
      link.click();
    },
    download(filename, base64, document) {
      let re = /(?:\.([^.]+))?$/;
      let extension = re.exec(filename)[1]

      const linkSource = "data:application/" + extension + ";base64," + base64;
      const downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.href = linkSource;
      downloadLink.target = '_self';
      downloadLink.download = filename;
      downloadLink.click();
    },
    getDocumentoMinio(type, clave, filename) {
      this.$apollo.query({
        query: GET_FILE_BY_TYPE_CLAVE_FILENAME,
        variables: {
          type: type,
          clave: clave,
          filename: filename
        },
        fetchPolicy: 'no-cache'
      }).then((data) => {
        let documentoMinio = data.data.getFileByTypeAndClaveAndFilename;
        this.download(documentoMinio.filename, documentoMinio.base64, document);
      }).catch((error) => {
        console.error(error)
      })
    },
    getDocumentoById(fileId) {
      this.$apollo.query({
        query: GET_FILE_BY_ID,
        variables: {
          id: fileId
        },
        fetchPolicy: 'no-cache'
      }).then((data) => {
        const documentoMinio = data.data.getFileById;
        this.download(documentoMinio.filename, documentoMinio.base64, document);
      }).catch(() => {
        this.$toast.add({ severity: 'error', summary: 'Error al descargar el fichero', detail: 'Ha ocurrido un error al descargar el fichero, inténtelo de nuevo.', life: 3000 });
      })
    }
  }
};
export default DownloadsMixin;
